import { Directive, ElementRef, Input, OnInit, AfterViewInit, OnDestroy, NgZone } from '@angular/core';

export interface PerfectScrollbarConfigInterface {
  wheelSpeed?: number;
  wheelPropagation?: boolean;
  minScrollbarLength?: number;
  suppressScrollX?: boolean;
  suppressScrollY?: boolean;
  swipeEasing?: boolean;
  useBothWheelAxes?: boolean;
  scrollXMarginOffset?: number;
  scrollYMarginOffset?: number;
}

@Directive({
  standalone: false,
  selector: '[ngxPerfectScrollbar]',
  exportAs: 'ngxPerfectScrollbar'
})
export class PerfectScrollbarDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input('ngxPerfectScrollbar') config: PerfectScrollbarConfigInterface = {};

  constructor(
    private el: ElementRef,
    private zone: NgZone
  ) {}

  ngOnInit() {
    // Apply basic overflow styles as a fallback
    const element = this.el.nativeElement as HTMLElement;
    element.style.overflow = 'auto';
    if (this.config?.suppressScrollX) {
      element.style.overflowX = 'hidden';
    }
    if (this.config?.suppressScrollY) {
      element.style.overflowY = 'hidden';
    }
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  scrollToTop(offset?: number, speed?: number): void {
    const element = this.el.nativeElement as HTMLElement;
    element.scrollTop = offset || 0;
  }

  scrollToBottom(offset?: number, speed?: number): void {
    const element = this.el.nativeElement as HTMLElement;
    element.scrollTop = element.scrollHeight - (offset || 0);
  }

  scrollToLeft(offset?: number, speed?: number): void {
    const element = this.el.nativeElement as HTMLElement;
    element.scrollLeft = offset || 0;
  }

  scrollToRight(offset?: number, speed?: number): void {
    const element = this.el.nativeElement as HTMLElement;
    element.scrollLeft = element.scrollWidth - (offset || 0);
  }

  scrollToElement(query: string, offset?: number, speed?: number): void {
    const element = this.el.nativeElement as HTMLElement;
    const target = element.querySelector(query) as HTMLElement;
    if (target) {
      element.scrollTop = target.offsetTop - (offset || 0);
    }
  }

  update(): void {
    // No-op for stub implementation
  }
}
